import React, { useState } from "react";
import { Colors } from "../Constants/colors";
import placeHolderImage from "./../images/user-image-placeholder.png";
import logoutIcon from "./../images/logout.svg";
import { useUserStore } from "../hooks/userHooks/user.hooks";
import { logout } from "../Services/users/users.service";
import { useDispatch } from "react-redux";
import { setShowSideMenuBar } from "../Redux/Slices/sideMenu.slice";
import notificationIcon from "./../images/notification-icon.svg";
import { useMobile } from "../hooks/deviceHooks/useDevice.hooks";
import { IconWithBadge } from "./IconWithBadge";
import { NotificationModal } from "./NotificationComponent/NotificationModal";
import queryClient from "../config/queryClient";
import { Notifications_key } from "../hooks/notifications/notifications.hooks";
import { useSocketListener } from "../hooks/socketHooks/socket.hooks";
import { SocketEventEnum } from "../Constants/Enums/Socket.enum";
import { getValue } from "../utils/object.utils";
import {
  useGetUnseenNotificationsCount,
  useMarkNoticationAsRead,
} from "../hooks/notificationHooks/notifications.hooks";
import { setErrorMessage } from "../Redux/Slices/alert.slice";
import { parseApiError } from "../Helper/apiError.helper";

export const Navbar = () => {
  const { user } = useUserStore();
  const isMobile = useMobile();
  const dispatch = useDispatch();

  const [openNotification, setOpenNotification] = useState(false);
  const [socketNotificationCount, setSocketNotificationCount] = useState(0);

  const { data: unSeenNotificationsCount } = useGetUnseenNotificationsCount();

  useSocketListener({
    eventName: SocketEventEnum.UNSEEN_NOTIFICATIONS_COUNT,
    handlerFunction: (countData) => {
      const count = getValue(countData, "unSeenNotificationsCount", 0);

      setSocketNotificationCount(count);
    },
  });

  const { mutate: markNotificationAsRead } = useMarkNoticationAsRead({
    onSuccess: () => {
      setSocketNotificationCount(0);
    },
    onError: (error) => {
      dispatch(setErrorMessage(parseApiError(error)));
    },
  });

  const handleMarkNotificationAsRead = () => {
    markNotificationAsRead();
  };

  const onLogout = () => {
    logout();
  };

  //TODO -> Make the logout button in dropdown.
  return (
    <div
      className="h-16 w-full flex flex-row justify-between items-center px-6 py-9"
      style={{
        backgroundColor: Colors.White,
        boxShadow: "rgba(17, 12, 46, 0.15) 0px 48px 100px 0px",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
      }}
    >
      {isMobile ? (
        <div
          onClick={() => {
            dispatch(setShowSideMenuBar(true));
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="30"
            height="30"
            viewBox="0 0 50 50"
          >
            <path
              d="M 5 8 A 2.0002 2.0002 0 1 0 5 12 L 45 12 A 2.0002 2.0002 0 1 0 45 8 L 5 8 z M 5 23 A 2.0002 2.0002 0 1 0 5 27 L 45 27 A 2.0002 2.0002 0 1 0 45 23 L 5 23 z M 5 38 A 2.0002 2.0002 0 1 0 5 42 L 45 42 A 2.0002 2.0002 0 1 0 45 38 L 5 38 z"
              fill="#7C0303"
            ></path>
          </svg>
        </div>
      ) : (
        <></>
      )}

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
          justifyContent: "flex-end",
          gap: 16,
          alignItems: "center",
        }}
      >
        <div className="flex flex-row w-fit">
          <div className="flex flex-col justify-between">
            <div>{user?.first_name}</div>
            <div className="text-xs" style={{ color: Colors.Grey }}>
              {user?.role}
            </div>
          </div>

          <div className="w-5" />
          <div
            className=""
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              overflow: "hidden",
            }}
          >
            <img
              src={placeHolderImage}
              alt="placeHolder"
              style={{ objectFit: "cover" }}
            />
          </div>
        </div>
        <div
          style={{
            position: "relative",
          }}
        >
          <IconWithBadge
            img={notificationIcon}
            badgeValue={socketNotificationCount || unSeenNotificationsCount}
            onClick={() => {
              setOpenNotification(true);
              queryClient.invalidateQueries({
                queryKey: [Notifications_key.GET_NOTIFICATIONS],
              });
              handleMarkNotificationAsRead();
            }}
          />
          <div>
            <NotificationModal
              open={openNotification}
              onClose={() => [setOpenNotification(false)]}
              wrapperStyle={{
                position: "absolute",
                top: 35,
                left: -210,
              }}
            />
          </div>
        </div>

        <div
          className="w-10 flex justify-center items-center"
          style={{
            cursor: "pointer",
          }}
          onClick={onLogout}
        >
          <img
            src={logoutIcon}
            alt="logout"
            style={{
              width: "25px",
              height: "25px",
            }}
          />
        </div>
      </div>
    </div>
  );
};
